import {computed, ref} from "@nuxtjs/composition-api";
import {MaybeRefOrGetter, toValue} from "@vueuse/shared";
import useRequest from "~/composables/useRequest";
import {getCalendarFilter} from "~/services/product";
import {dayjs, get} from "~/utils/helpers";
import {useRouteQuery} from "@/composables/router";

interface UseCruiseCalendarFilterParam {
    route?: string;
    cruise_route_first?: string;
    city?: string;
}

export function useCruiseCalendarFilter() {

    const cruiseRouteFirst = useRouteQuery<string>("f_r", ''); // 一级航线
    const cruiseRouteSecondary = useRouteQuery<string>("s_r", ''); // 二级航线
    const city = useRouteQuery<string>("c", '');

    const {state, execute, isReady} = useRequest(
        () =>
            getCalendarFilter({
                route: toValue(cruiseRouteSecondary),
                cruise_route_first: toValue(cruiseRouteFirst),
                city: toValue(city),
            }),
        {
            banner: [],
            travel_date: [],
            port: [],
            route: [],
            defaultParam: {
                city: "",
                cruise_route_first: "",
                route: "",
            },
        },
        {
            immediate: false,
            resetOnExecute: false,
            onSuccess: (res) => {
                cruiseRouteFirst.value = get(res, ['defaultParam', 'cruise_route_first'], '')
                // cruiseRouteSecondary.value = get(res, ['defaultParam', 'route'], '')
                // travel.value = get(res, ['travel_date', 0], '');
            },
            onError: (err) => console.error(err),
        }
    );
  const travel = useRouteQuery<string>("t", () => get(state.value, ['travel_date', 0], ''));

    const routes = computed(() => state.value.route.map((item) => ({
        value: item.id,
        label: item.name,
        query: {
            f_r: item.id,
            // s_r: get(item, ['list', 0, 'id'], ''),
            s_r:'',
            city: ''
        },
        list: item.list.map((val) => ({
            value: val.id,
            label: val.name,
            query: {
                f_r: item.id,
                s_r: val.id,
                city: ''
            }
        })),
    })))
    const cities = computed(() => {
        return state.value.port.map((item) => ({
            value: item.departure_city_id,
            label: item.departure,
            query: {
                f_r: toValue(cruiseRouteFirst),
                s_r: toValue(cruiseRouteSecondary),
                c: item.departure_city_id
            }
        }))
    })

    const months = computed(() => {
        return state.value.travel_date.map((item) => {
            const dayjsObj = dayjs([item, "1"].join("-"));
            return {
                year: dayjsObj.year(),
                month: dayjsObj.month(),
                label: dayjsObj.format("YYYY年MM月"),
                value: item,
            };
        });
    });

    // 被选中的一级航线
    const checkedFirstRoute = computed(() => {

        return routes.value.find(
            (item) => item.value === cruiseRouteFirst.value
        );
    });

    return {
        isReady,
        state,
        execute,
        cities,
        routes,
        months,
        checkedFirstRoute,

        cruiseRouteFirst,
        cruiseRouteSecondary,
        city,
        travel,
    };
}
